import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SettingsPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div style={styles.page}>

      {/* ---------------- TOP NAV BAR ---------------- */}
      <div style={styles.navbar}>
        <div onClick={() => setMenuOpen(!menuOpen)} style={styles.menuIcon}>
          &#9776;
        </div>
        <h3 style={styles.navTitle}>Settings</h3>
      </div>

      {/* ---------------- LEFT SIDEBAR MENU ---------------- */}
      {menuOpen && (
        <div style={styles.sidebar}>
          <p style={styles.menuItem} onClick={() => navigate("/profile")}>
            Profile
          </p>
          <p style={styles.menuItem} onClick={() => navigate("/orders")}>
            My Orders
          </p>
          <p style={styles.menuItem} onClick={() => navigate("/offers")}>
            Offers
          </p>
          <p style={styles.menuItem} onClick={() => navigate("/feedback")}>
            Feedback
          </p>
          <p
            style={{ ...styles.menuItem, color: "red" }}
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
          >
            Logout
          </p>
        </div>
      )}

      {/* ---------------- MAIN SETTINGS PAGE ---------------- */}
      <div style={styles.container}>
        <h2 style={styles.heading}>Account Settings</h2>

        <div style={styles.card} onClick={() => navigate("/profile")}>
          <span>Edit Profile</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card} onClick={() => navigate("/change-phone")}>
          <span>Change Phone Number</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card} onClick={() => navigate("/change-password")}>
          <span>Change Password</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <h2 style={styles.heading}>App Preferences</h2>

        <div style={styles.card}>
          <span>Notifications</span>
          <span style={styles.switch}>ON</span>
        </div>

        <div style={styles.card} onClick={() => navigate("/location-settings")}>
          <span>Location Settings</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card}>
          <span>Dark Mode</span>
          <span style={styles.switch}>OFF</span>
        </div>

        <h2 style={styles.heading}>Help & Support</h2>

        <div style={styles.card} onClick={() => navigate("/help")}>
          <span>Help Center</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card} onClick={() => navigate("/chat-pharmacist")}>
          <span>Chat with Pharmacist</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card} onClick={() => navigate("/contact-support")}>
          <span>Contact Support</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <h2 style={styles.heading}>About App</h2>

        <div style={styles.card}>
          <span>Terms & Conditions</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <div style={styles.card}>
          <span>Privacy Policy</span>
          <span style={styles.arrow}>&gt;</span>
        </div>

        <p style={styles.version}>App Version 1.0.0</p>
      </div>
    </div>
  );
}

/* ========== STYLES ========== */
const styles = {
  page: {
    background: "#f4f7fc",
    height: "100vh",
  },

  navbar: {
    display: "flex",
    alignItems: "center",
    background: "white",
    padding: "14px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },

  menuIcon: {
    fontSize: "22px",
    cursor: "pointer",
    marginRight: "20px",
  },

  navTitle: {
    fontWeight: "bold",
    fontSize: "20px",
    margin: 0,
  },

  sidebar: {
    position: "absolute",
    top: "60px",
    left: "10px",
    width: "160px",
    background: "white",
    borderRadius: "10px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    padding: "10px",
    zIndex: 20,
  },

  menuItem: {
    padding: "10px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    fontSize: "15px",
  },

  container: {
    padding: "20px",
    marginTop: "10px",
  },

  heading: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "20px",
  },

  card: {
    background: "white",
    padding: "14px",
    borderRadius: "10px",
    marginTop: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
  },

  arrow: {
    fontSize: "18px",
    color: "#888",
  },

  switch: {
    fontWeight: "bold",
    color: "#007bff",
  },

  version: {
    textAlign: "center",
    marginTop: "30px",
    color: "#777",
    fontSize: "14px",
  },
};
